module.exports = __webpack_public_path__ + "static/media/suite atlassian.12d5a002.png";